import Vue from 'vue';


/** 创建模态框使用 */
export const use_modal = ({
	initial_status,
	callback
} = {}) => {
	// 状态切换队列
	let toggle_queue = [
		'showing', 'showed', 'hiding', 'hidden'
	];

	// 状态切换队列排序
	if (typeof initial_status !== 'undefined') {
		const status_index = toggle_queue.indexOf( initial_status );

		toggle_queue = toggle_queue
			.slice( status_index + 1 )
			.concat(
				toggle_queue.slice(0, status_index + 1)
			)
		;
	}


	const store = {
		status: initial_status || 'hidden'
	};

	const toggle = (custom_status) => {
		const status_index = toggle_queue.indexOf( custom_status );

		if (status_index !== -1) {
			toggle_queue = toggle_queue
				.slice( status_index )
				.concat(
					toggle_queue.slice(0, status_index)
				)
			;
		}


		const status = toggle_queue.shift();

		toggle_queue.push( status );

		callback && callback(status);

		store.status = status;
	};


	return { toggle, store };
};
